module.exports = __webpack_public_path__ + "img/cs.1b0be87c.svg";